var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('audio',{ref:"audioPlayerRef",staticClass:"audio-player",attrs:{"id":"ai-player-audio-id","src":_vm.srcLocalUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }